import { RootAppState } from 'store/configureStore'

export const bomItemSearchedSelector = (state: RootAppState) => {
  return state.project.searchedBomItemId
}

export const bomItemIsSearchedSelector =
  (bomItemId: string) => (state: RootAppState) => {
    return state.project.searchedBomItemId === bomItemId
  }

export const bomItemSelectedSelector =
  (bomItemId: string) => (state: RootAppState) => {
    return state.project?.selectedBomItemIds?.includes(bomItemId)
  }

export const headerIsSelectedSelector =
  (headerId: string) => (state: RootAppState) => {
    if (!state.project?.selectedBomItemIds?.length) {
      return 'none'
    }

    const header = state.project?.flatView[headerId]

    if (header?.type === 'Row' || header?.type === 'Assembly') {
      return 'none'
    }

    if (
      header.filteredPartTypeIds.every((id) =>
        state.project?.selectedBomItemIds?.includes(id)
      )
    ) {
      return 'all'
    }

    if (
      header.filteredPartTypeIds.some((id) =>
        state.project?.selectedBomItemIds?.includes(id)
      )
    ) {
      return 'some'
    }

    return 'none'
  }

export const bomItemSelectedCounter = (state: RootAppState) => {
  return state.project?.selectedBomItemIds?.length
}
